import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ShareConfigType } from '../type';

const initialState = {
  androidAPKUrl: '', // 安卓下载包链接
  iosAppUrl: '', // ios 安装包链接
  androidQRCodeUrl: '',
  iosQRCodeUrl: '',
  discoverSchema: {
    ios: '',
    android: '',
  },
  shareIOSAppStoreQrcode: '',
  shareAndroidDownloadQrcode: '',
};

export const shareSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setAndroidAPKUrl: (state, action: PayloadAction<string>) => {
      state.androidAPKUrl = action.payload;
    },
    setIosAppUrl: (state, action: PayloadAction<string>) => {
      state.iosAppUrl = action.payload;
    },
    setAndroidQRCodeUrl: (state, action: PayloadAction<string>) => {
      state.androidQRCodeUrl = action.payload;
    },
    setIosQRCodeUrl: (state, action: PayloadAction<string>) => {
      state.iosQRCodeUrl = action.payload;
    },
    setShareConfigState: (state, action: PayloadAction<Partial<ShareConfigType>>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const {
  setAndroidAPKUrl,
  setIosAppUrl,
  setAndroidQRCodeUrl,
  setIosQRCodeUrl,
  setShareConfigState,
} = shareSlice.actions;

export default shareSlice.reducer;
